var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2542",
    "data-name": "Group 2542",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.552,
    height: 23.624,
    viewBox: "0 0 23.552 23.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2541",
    "data-name": "Group 2541",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5208",
    "data-name": "Path 5208",
    d: "M23.942,10.324a.555.555,0,0,0,.267-1.041L13.049.941a.556.556,0,0,0-.665,0L1.168,9.325a.555.555,0,0,0,.332,1H23.942ZM3.168,9.215l9.548-7.137,9.548,7.137Z",
    transform: "translate(-0.945 -0.83)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5209",
    "data-name": "Path 5209",
    d: "M3.179,59.614H24.725a.555.555,0,0,0,.555-.555V57.168a.555.555,0,0,0-.555-.555H22.9V49.17a.555.555,0,0,0-1.11,0v7.444H19.91V49.17a.555.555,0,0,0-1.11,0v7.444H16.086V49.17a.555.555,0,0,0-1.11,0v7.444H13.02V49.17a.555.555,0,0,0-1.11,0v7.444H9.456V49.17a.555.555,0,0,0-1.11,0v7.444H6.389V49.17a.555.555,0,0,0-1.11,0v7.444h-2.1a.555.555,0,0,0-.555.555v1.891A.555.555,0,0,0,3.179,59.614Zm.555-1.891H24.17V58.5H3.734Z",
    transform: "translate(-2.18 -35.99)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5210",
    "data-name": "Path 5210",
    d: "M12.325,40.6a.555.555,0,1,0,0,1.11h3.454a.555.555,0,0,0,0-1.11Z",
    transform: "translate(-8.91 -30.097)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5211",
    "data-name": "Path 5211",
    d: "M37.419,40.6a.555.555,0,0,0,0,1.11h3.454a.555.555,0,1,0,0-1.11Z",
    transform: "translate(-27.374 -30.097)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5212",
    "data-name": "Path 5212",
    d: "M63.37,40.6a.555.555,0,1,0,0,1.11h3.453a.555.555,0,1,0,0-1.11Z",
    transform: "translate(-46.469 -30.097)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5213",
    "data-name": "Path 5213",
    d: "M36.56,14.823a2.3,2.3,0,1,0,4.162-1.341.555.555,0,1,0-.9.647,1.188,1.188,0,1,1-.964-.493.555.555,0,0,0,0-1.11A2.3,2.3,0,0,0,36.56,14.823Z",
    transform: "translate(-27.151 -9.436)",
    fill: "#bbc6d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.86e828f7.svg";
export { ForwardRef as ReactComponent };